<template>
  <div class="goal-content body-content page-card-wrapper">
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.productivity_goal')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-30 page-content">
        <div class="slider-text mb-30">
          {{ $t('text.day_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100">
          <span
            v-if="dayValue"
            class="value-text slider-text"
            :style="{ left: dayValue / (this.max / 100) + '%' }"
            >{{ dayValueText }}</span
          >
          <el-slider
            v-model="dayValue"
            :min="0"
            :max="max"
            :step="1"
            :show-tooltip="false"
          >
          </el-slider>
          <div class="min-value slider-text">{{ $t('text.off') }}</div>
          <div class="max-value slider-text">{{ max }}</div>
        </div>
        <div class="slider-text mt-20">
          {{ $t('text.night_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100 mt-30">
          <span
            v-if="nightValue"
            class="value-text slider-text"
            :style="{ left: nightValue / (this.max / 100) + '%' }"
            >{{ nightValueText }}</span
          >
          <el-slider
            v-model="nightValue"
            :min="0"
            :max="max"
            :step="1"
            :show-tooltip="false"
          >
          </el-slider>
          <div class="min-value slider-text">{{ $t('text.off') }}</div>
          <div class="max-value slider-text">{{ max }}</div>
        </div>
        <div class="text-right mt-10">
          <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
            $t('text.default').toUpperCase()
          }}</b-button>
          <el-button
            type="success"
            plain
            class="common-btn"
            :loading="saveLoading"
            @click="save()"
            :disabled="saveLoading"
            v-if="p('Patients.Goals.Position.Add')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
        </div>
        <div class="setting-wrapper mt-40 mb-30">
          <div class="image-wrapper inline-block">
            <img src="@/assets/image/light.svg" />
          </div>
          <div class="inline-block">
            <div>{{ $t('text.presently') }}:</div>
            <div>
              {{ patientData.DayDiaperUsed || 0 }}
              {{
                $t('text.diapers_per_person_daytime', {
                  pads: this.$store.state.locale.pads
                })
              }}
            </div>
            <div>
              {{ patientData.NightDiaperUsed || 0 }}
              {{
                $t('text.diapers_per_person_night', {
                  pads: this.$store.state.locale.pads
                })
              }}
            </div>
            <div>
              {{ patientData.AverageDiaperUsed || 0 }}
              {{
                $t('text.diapers_per_person_day', {
                  pads: this.$store.state.locale.pads
                })
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dayValue: 0,
      nightValue: 0,
      max: 5,
      goal: {},
      patientData: {},
      saveLoading: false
    }
  },
  watch: {
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    },
    '$store.state.patient.selectedPatientData': function() {
      this.getPatientData()
    }
  },
  computed: {
    dayValueText: function() {
      return `${this.dayValue} ${this.$t('text.diapers_per_person', {
        pads: this.$store.state.locale.pads
      })}`
    },
    nightValueText: function() {
      return `${this.nightValue} ${this.$t('text.diapers_per_person', {
        pads: this.$store.state.locale.pads
      })}`
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
    this.getInitVal()
    this.getPatientData()
  },
  methods: {
    getInitVal() {
      this.goal = this.$store.state.patient.selectedPatientGoal
      this.dayValue = this.goal.MaxDayDiaper
      this.nightValue = this.goal.MaxNightDiaper
    },
    getPatientData() {
      this.patientData = this.$store.state.patient.selectedPatientData
    },
    save() {
      if (!this.$store.state.patient.selectedPatient) return false
      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MaxDayDiaper: this.dayValue,
        MaxNightDiaper: this.nightValue
      }
      this.saveLoading = true
      ApiService.SaveProductivityGoal(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            this.$store.dispatch('patient/getSelectedPatientHistoryData')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>
